import { gsap } from 'gsap';
import { getScopedViewportHeight } from '../viewport-utils';

export default function initAnimation(root: HTMLElement) {
    const mm = gsap.matchMedia();
    const breakPoint = 640;

    mm.add(
        {
            // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
            isDesktop: `(min-width: ${breakPoint}px) and (prefers-reduced-motion: no-preference)`,
            isMobile: `(max-width: ${
                breakPoint - 1
            }px) and (prefers-reduced-motion: no-preference)`,
        },
        (context) => {
            // 如果 context.conditions 是 undefined，我们不能继续使用它。
            if (!context.conditions) {
                console.error('No conditions available');
                return;
            }

            // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
            const { isDesktop, isMobile } = context.conditions;

            if (!isDesktop) {
                return;
            }

            const cards = gsap.utils.toArray<HTMLElement>('.card');

            cards.pop();

            cards.forEach((card, i) => {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: card,
                        start: 'center center',
                        pinSpacing: false,
                        pin: true,
                        scrub: true,
                        // set the transformOrigin so that it's in the center vertically of the viewport when the element's bottom hits the bottom of the viewport
                        onRefresh: () =>
                            gsap.set(card, {
                                transformOrigin:
                                    'center ' +
                                    (card.offsetHeight -
                                        getScopedViewportHeight(root) / 2) +
                                    'px',
                            }),
                    },
                });

                tl.fromTo(
                    card,
                    { y: 0, rotate: 0, scale: 1 },
                    { y: 0, rotateX: 0, scale: 0.5 },
                    0,
                ).to(card, { opacity: 0 });
            });
        },
    );

    return () => {
        mm.revert();
    };
}
